export default __webpack_public_path__ + "static/media/mastercard-logo.f23ccf66.svg";